import {useMutation, useQueryClient} from "@tanstack/react-query";
import {message} from "antd";
import {useClientV2} from "../../../../utils/hooks";
import type {AddSubscriptionTiersRequestBody} from "../tiers/types";
import {formatTierMutationError} from "../tiers/format-tier-mutation-error";
import {invalidateSubscriptionAfterTierChange} from "../tiers/invalidate-after-tier-change";

export const useAddSubscriptionTiersApi = () => {
  const queryClient = useQueryClient();
  const client = useClientV2();

  return useMutation({
    mutationFn: async ({
      subscriptionId,
      body,
    }: {
      subscriptionId: number;
      body: AddSubscriptionTiersRequestBody;
    }) => {
      return client(`subscriptions/${subscriptionId}/tiers`, {
        method: "POST",
        data: body,
      });
    },
    onError: (error: unknown) => {
      message.error(formatTierMutationError(error));
    },
    onSettled: (_, __, {subscriptionId}) => {
      invalidateSubscriptionAfterTierChange(queryClient, subscriptionId);
    },
  });
};
